import script from "./CompleteAccountView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompleteAccountView.vue?vue&type=script&setup=true&lang=ts"

import "./CompleteAccountView.vue?vue&type=style&index=0&id=43d24def&scoped=true&lang=css"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43d24def"]])

export default __exports__